module.exports = __webpack_public_path__ + "img/facebook.811e818f.svg";